import useStore from '../contexts/JWTContext';

// ----------------------------------------------------------------------

const useAuth = () => useStore();

export default useAuth;
